module.exports = __webpack_public_path__ + "img/saint-martin.ab83ac98.svg";